import companyService from '@/services/company.service';

const state = {
  company: null,
  loading: false,
  error: null,
};

const getters = {
  company: (state) => state.company,
  isLoading: (state) => state.loading,
  error: (state) => state.error,
};

const actions = {
  /**
   * Fetch company of current user
   */
  async fetchCompany({ commit }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    
    try {
      const response = await companyService.getCompany();
      commit('SET_COMPANY', response);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to fetch company';
      commit('SET_ERROR', errorMessage);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  /**
   * Update company of current user
   */
  async updateCompany({ commit }, companyData) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    
    try {
      const response = await companyService.updateCompany(companyData);
      commit('SET_COMPANY', response.company);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to update company';
      commit('SET_ERROR', errorMessage);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  /**
   * Clear company data
   */
  clearCompany({ commit }) {
    commit('SET_COMPANY', null);
    commit('SET_ERROR', null);
  },
};

const mutations = {
  SET_COMPANY(state, company) {
    state.company = company;
  },
  
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};